function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  <div class=\"flash-item flash-item_", "\">\n    <div class=\"flash-item__body flash-item__body_", "\">\n      <div class=\"flash-item__close\" />\n      ", "\n    </div>\n  </div>\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import $ from 'jquery';
import html from './html';

var flash = function flash(group, message) {
  return html(_templateObject(), group, group, message);
};

var add = function add(group, message) {
  $('#flashes').append(flash(group, message));
  timedAll();
};

var hide = function hide(flashItem) {
  flashItem.classList.add('flash-item_closed');
};

var delegateClick = function delegateClick(event) {
  var flashItem = event.target.closest('.flash-item');
  if (!flashItem) return;
  hide(flashItem);
  event.preventDefault();
};

var timedElement = function timedElement(element) {
  setTimeout(function () {
    hide(element);
  }, 5000);
  element.classList.add('flash-item_timed');
};

var timedAll = function timedAll() {
  var elements = document.querySelectorAll('.flash-item_notice:not(.flash-item_timed)');

  _toConsumableArray(elements).forEach(function (element) {
    return timedElement(element);
  });
};

var start = function start() {
  document.addEventListener('click', delegateClick);
  document.addEventListener('page:load', timedAll);
  document.addEventListener('ajax:success', timedAll);
};

export default {
  add: add,
  hide: hide,
  timedAll: timedAll,
  timedElement: timedElement,
  start: start
};